import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import TrustStrip from "@/components/TrustStrip";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import NewsletterPopup from "@/components/NewsletterPopup";

export default function Layout() {
  const location = useLocation();

  // Scroll to top on route change (unless there's a hash)
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    } else {
      // Smooth scroll to anchor after a brief delay to allow render
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
    // Fire a Meta Pixel PageView on every client-side route change (the base
    // pixel in index.html only fires once on the very first document load).
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
    // Fire a GA4 page_view on every client-side route change. The gtag base
    // config only tracks the initial document load; SPA transitions need
    // this explicit event with the current path + title.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search + location.hash,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2C2B29] flex flex-col">
      {location.pathname === "/" && <TrustStrip />}
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
      <NewsletterPopup />
    </div>
  );
}
